export default "__VITE_ASSET__B13oQOjb__"